import { useMemo } from 'react'

import { Offer } from '@wwt/entities/search-response'

import { useGetReservation } from '@/entities/reservation'
import { DEFAULT_LOCAL_RESERVATION_ID } from '@/pages/ReservationLoadPage/config/defaultLocalReservationId'
import { getShowedContentType } from '@/shared/utils'

export const useReservationTab = (offer: Offer | null) => {
	const queryData = useGetReservation(
		offer?.IDs.wwtOfferId ?? DEFAULT_LOCAL_RESERVATION_ID
	)

	const showedContentType = useMemo(
		() =>
			getShowedContentType(
				queryData.isPending,
				queryData.isError,
				queryData.data
			),
		[queryData.isPending, queryData.data, queryData.isError]
	)
	return {
		showedContentType,
		reservationData: queryData.data
	}
}
